<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="白名单"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="title">
        <van-icon style="font-size: 1.125rem" class="iconfont icon-mima" />
        <span class="titPass">白名单密码：{{ passWord }}</span>
      </div>
      <van-divider />
      <div class="canOpenNum">
        <span>可开门的{{h5Config.textCfg.roomName}}</span>
        <span>共{{ num }}个</span>
      </div>
      <div class="roomList">
        <!-- <div class="roomItem" v-for="item in roomList" :key="item.id">
          {{ item.name }}
        </div> -->
        <div v-if="roomList.length !== 0">
          <van-row>
            <van-col
              class="roomItem"
              v-for="item in roomList"
              :key="item.id"
              span="6"
            >
              <div class="itemWrap">
                <span class="roomText">{{h5Config.textCfg.roomName}}{{ item.name }}</span>
              </div>
            </van-col>
          </van-row>
        </div>
        <van-empty v-else description="暂无数据" />
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
// import * as constant from '../../api/constant'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      passWord: '',
      num: 34,
      roomList: [

      ]
    }
  },
  mounted () {
    this.getWhiteName()
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    getWhiteName () {
      Toast.loading({
        message: '加载中',
        forbidClick: true
      })
      const para = {

      }
      api
        .axiosRequest(api.urlList.getWhiteNameList, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Toast.clear()
            if (res.room_names && res.room_names.length > 0) {
              const arr = []
              res.room_names.forEach((x, xIndex) => {
                const reg1 = new RegExp(this.h5Config.textCfg.roomName, 'g')
                if (x.indexOf(this.h5Config.textCfg.roomName) !== -1) {
                  x = x.replace(reg1, '')
                }
                arr.push({
                  id: xIndex,
                  name: x
                })
              })

              this.roomList = arr
              this.passWord = res.password
              this.num = res.room_names.length
            } else {
              this.roomList = []
              this.passWord = '暂无密码'
              this.num = 0
            }
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      //   Toast('返回')
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="scss">
.content_box {
  .title {
    font-size: 1.125rem;
    color: #333;
    .titPass {
      margin-left: 0.625rem;
    }
  }
  padding: 1rem;
  .canOpenNum {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    color: #999999;
  }
  .roomList {
    // display: flex;
    // align-items: center;
    // justify-content: flex-start;
    // flex-wrap: wrap;
    .roomItem {
      // width: 25%;
      // width: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      margin-top: 1.2rem;
      // margin-left: 4px;
      // margin-right: 4px;
      color: #74b0f9;
      font-size: 1rem;
      // border: 1px solid #74b0f9;
      // padding: 0.25rem 0.5rem;
      // border-radius: 0.25rem;
      .itemWrap {
        border: 1px solid #74b0f9;
        width: 80%;
        border-radius: 4px;
        padding: 4px;
      }
      .roomText {
        width: 3.125rem;

        // padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
      }
    }
  }
}
</style>
